// if( document.querySelector( '.sww-widget-customer-2024' ).length !== 0 ) {
if( document.querySelector( '.sww-widget-customer-2024' ) ) {
    var customerWidget = Object.assign( {}, customerWidget, {
        annualConsumption: document.querySelector( '.sww-widget-customer-2024' ).querySelector( '#cu24-annual-consumption' ),
        container: document.querySelector( '.sww-widget-customer-2024' ),
        electricitySlider: document.querySelector( '.sww-widget-customer-2024' ).querySelector( '#cu24-persons' ),
        gasSlider: document.querySelector( '.sww-widget-customer-2024' ).querySelector( '#cu24-living-space' ),
        icons: document.querySelector( '.sww-widget-customer-2024' ).querySelector( '.energy-switch' ).querySelectorAll( '.icon' ),
        calculateElectricity: function( value ) {
            var annualConsumption = 0;
            switch( value ) {
                case '1':
                    annualConsumption = '1200 kWh';
                    break;
                case '2':
                    annualConsumption = '2400 kWh';
                    break;
                case '3':
                    annualConsumption = '3600 kWh';
                    break;
                case '4':
                    annualConsumption = '4800 kWh';
                    break;
                case '5':
                    annualConsumption = '6000 kWh';
                    break;
                case '6':
                    annualConsumption = '7200 kWh';
                    break;
                default:
                    annualConsumption = '1200 kWh';
                    break;
            }
            customerWidget.annualConsumption.value = annualConsumption;
            return;
        },
        calculateGas: function( value ) {
            var annualConsumption = 0;
            switch( value ) {
                case '25':
                    annualConsumption = '4800 kWh';
                    break;
                case '50':
                    annualConsumption = '8000 kWh';
                    break;
                case '75':
                    annualConsumption = '12000 kWh';
                    break;
                case '100':
                    annualConsumption = '16000 kWh';
                    break;
                case '125':
                    annualConsumption = '20000 kWh';
                    break;
                case '150':
                    annualConsumption = '24000 kWh';
                    break;
                default:
                    annualConsumption = '4800 kWh';
                    break;
            }
            customerWidget.annualConsumption.value = annualConsumption;
            return;
        },
        formSubmit: function( event ) {
            event.preventDefault();
            var form = customerWidget.container.querySelector( 'form' );
            var formData = new FormData( form );
            formData.append( 'action', 'cu24' );
            // formData.append( 'security', yondAPI.security );
            fetch( customerWidget.ajax_url, {
                method: 'POST',
                body: formData
            } )
            .then( function( response ) {
                return response.text();
            })
            .then( function( data ) {
                if( data === '1' ) {
                    customerWidget.callCalculator( formData );
                } else {
                    alert( 'Die Postleitzahl liegt außerhalb des zulässigen Postleitzahlenbereichs.' );
                }
            } )
            .catch( function( error ) { console.error(error); } );
            return false;
        },
        iconClick: function( event ) {
            if( customerWidget.icons.length === 1 ) {
                return false;
            }
            var energyType = '';
            customerWidget.icons.forEach( function( icon ) {
                if( icon.classList.contains( 'active' ) ) {
                    icon.classList.toggle( 'active' );
                }
            } );
            event.srcElement.parentElement.classList.toggle( 'active' );
            energyType = event.srcElement.parentElement.dataset.type;
            customerWidget.container.querySelector( 'input[ name="cu24-energy-type" ]' ).value = energyType;
            var calculationBases = customerWidget.container.querySelector( '.calculation-base' ).querySelectorAll( 'div' );
            calculationBases.forEach( function( calculationBase ) {
                calculationBase.classList.remove( 'active' );
                if( calculationBase.classList.contains( energyType ) ) {
                    calculationBase.classList.add( 'active' );
                    if( energyType === 'strom' ) {
                        customerWidget.calculateElectricity( customerWidget.electricitySlider.value );
                    } else if( energyType === 'erdgas' ) {
                        customerWidget.calculateGas( customerWidget.gasSlider.value );
                    }
                } 
            } );
            return false;
        },
        init: function() {
            customerWidget.icons.forEach( function( icon ) {
                icon.addEventListener( 'click', customerWidget.iconClick );
            } );
            if( customerWidget.electricitySlider !== null ) {
                customerWidget.electricitySlider.addEventListener( 'input', customerWidget.inputElectricity );
            }
            if( customerWidget.gasSlider !== null ) {
                customerWidget.gasSlider.addEventListener( 'input', customerWidget.inputGas );
            }
            // customerWidget.querySelector( 'input[ type="submit" ]' ).addEventListener(  );
            customerWidget.container.querySelector( 'form' ).addEventListener( 'submit', customerWidget.formSubmit );
        },
        inputElectricity: function( event ) {
            var value = customerWidget.electricitySlider.value;
            var scale = customerWidget.container.querySelector( '.calculation-base' ).querySelector( '.strom' ).querySelectorAll( '.step' );
            customerWidget.calculateElectricity( value );
            scale.forEach( function( scaleValue) {
                scaleValue.classList.remove( 'active' );
                if( scaleValue.dataset.persons === value ) {
                    scaleValue.classList.toggle( 'active' );
                }
            });
            return false;
        },
        inputGas: function( event ) {
            var value = customerWidget.gasSlider.value;
            var scale = customerWidget.container.querySelector( '.calculation-base' ).querySelector( '.erdgas' ).querySelectorAll( '.step' );
            customerWidget.calculateGas( value );
            scale.forEach( function( scaleValue) {
                scaleValue.classList.remove( 'active' );
                if( scaleValue.dataset.space === value ) {
                    scaleValue.classList.toggle( 'active' );
                }
            });
            return false;
        },
        callCalculator: function( formdata ) {
            var url = 'https://kunde-werden.stadtwerke-wolfhagen.de/';
            var params = new URLSearchParams();
            var energyType = '';
            formdata.forEach(function(value, key) {
                if( key === 'cu24-energy-type' ) {
                    switch( value ) {
                        case 'strom':
                            energyType = 'electricity';
                            break;
                        case 'erdgas':
                            energyType = 'natural_gas';
                            break;
                        case 'heizstrom':
                            energyType = 'electric_heating';
                            break;
                    }
                    params.append( 'energyType', energyType );
                }
                if( key === 'cu24-postalcode' ) {
                    params.append( 'zipCode', value );
                }
                if( key === 'cu24-annual-consumption' ) {
                    params.append( 'consumption', parseInt( value ) );
                }
                if( key === 'cu24-persons' && energyType === 'electricity' ) {
                    // params.append( 'consumptionPerEquivalent', value );
                    params.append( 'consumptionPerEquivalent', '1200' );
                }
                if( key === 'cu24-living-space' && energyType === 'natural_gas' ) {
                    params.append( 'consumptionPerEquivalent', value );
                }
                if( key === 'cu24-tag' && value !== '' ) {
                    params.append( 'tag', value );
                }
                if( key === 'cu24-product-id' && value !== '' ) {
                    params.append( 'productId', value );
                }
                if( key === 'cu24-device' && value !== '' ) {
                    params.append( 'category', value );
                }
            });
            var fullUrl = url + "?" + params.toString();
            window.open( fullUrl, '_blank');
            return;
        }
    });
    customerWidget.init(); 
}